import { get } from 'libs/GrebbCommerceAPI/util';

export default async () => {
    // Build parameters.

    return await get(`/gift-certificates`);
};
